export default {
  name: "formSysIndex",
  computed: {
    key: function key() {
      return this.$route.fullPath;
    }
  }
};